import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative mb-4 h-8 pt-2" }
const _hoisted_2 = ["min", "max", "step", "value"]
const _hoisted_3 = ["min", "max", "step", "value"]
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = ["min", "max", "step", "value"]
const _hoisted_6 = ["min", "max", "step", "value"]

import { ref, computed, watch } from "vue";
import { storeToRefs } from "pinia";

import {
	LOCATION_AREA_MIN,
	LOCATION_AREA_MAX,
	LOCATION_AREA_STEP,
	clampLocationArea,
	normalizeLocationAreaRange,
} from "~/js/composables/location-area";
import { useLocationsStore } from "~/js/store/locations";

interface Props {
	utilities?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterLocationAreaRange',
  props: {
    utilities: { default: "" }
  },
  setup(__props: any) {



const locationsStore = useLocationsStore();
const { filters } = storeToRefs(locationsStore);

const localMin = ref(filters.value.area.min);
const localMax = ref(filters.value.area.max);

watch(
	() => [filters.value.area.min, filters.value.area.max],
	([min, max]) => {
		localMin.value = min;
		localMax.value = max;
	},
);

const trackFillStyle = computed(() => {
	const range = LOCATION_AREA_MAX - LOCATION_AREA_MIN;
	const left = ((localMin.value - LOCATION_AREA_MIN) / range) * 100;
	const right = 100 - ((localMax.value - LOCATION_AREA_MIN) / range) * 100;

	return {
		left: `${left}%`,
		right: `${right}%`,
	};
});

const commit = () => {
	const { min, max } = normalizeLocationAreaRange(localMin.value, localMax.value);
	localMin.value = min;
	localMax.value = max;
	locationsStore.setAreaRange(min, max);
};

const onMinInput = (event: Event) => {
	const value = Number((event.target as HTMLInputElement).value);
	localMin.value = Math.min(value, localMax.value);
};

const onMaxInput = (event: Event) => {
	const value = Number((event.target as HTMLInputElement).value);
	localMax.value = Math.max(value, localMin.value);
};

const onMinNumberBlur = (event: Event) => {
	const value = clampLocationArea(Number((event.target as HTMLInputElement).value));
	localMin.value = Math.min(value, localMax.value);
	(event.target as HTMLInputElement).value = String(localMin.value);
	commit();
};

const onMaxNumberBlur = (event: Event) => {
	const value = clampLocationArea(Number((event.target as HTMLInputElement).value));
	localMax.value = Math.max(value, localMin.value);
	(event.target as HTMLInputElement).value = String(localMax.value);
	commit();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.utilities)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute top-1/2 h-1 w-full -translate-y-1/2 rounded-full bg-concrete-200" }, null, -1)),
      _createElementVNode("div", {
        class: "absolute top-1/2 h-1 -translate-y-1/2 rounded-full bg-viridian-500",
        style: _normalizeStyle(trackFillStyle.value)
      }, null, 4),
      _createElementVNode("input", {
        class: "range-thumb pointer-events-none absolute inset-x-0 top-1/2 z-10 h-0 w-full -translate-y-1/2 appearance-none bg-transparent [&::-moz-range-thumb]:pointer-events-auto [&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:cursor-pointer [&::-moz-range-thumb]:appearance-none [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:border-2 [&::-moz-range-thumb]:border-orange-500 [&::-moz-range-thumb]:bg-viridian-500 [&::-webkit-slider-thumb]:pointer-events-auto [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:border-orange-500 [&::-webkit-slider-thumb]:bg-viridian-500",
        type: "range",
        min: _unref(LOCATION_AREA_MIN),
        max: _unref(LOCATION_AREA_MAX),
        step: _unref(LOCATION_AREA_STEP),
        value: localMin.value,
        "aria-label": "Minimum rentable surface",
        onInput: onMinInput,
        onChange: commit
      }, null, 40, _hoisted_2),
      _createElementVNode("input", {
        class: "range-thumb pointer-events-none absolute inset-x-0 top-1/2 z-20 h-0 w-full -translate-y-1/2 appearance-none bg-transparent [&::-moz-range-thumb]:pointer-events-auto [&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:cursor-pointer [&::-moz-range-thumb]:appearance-none [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:border-2 [&::-moz-range-thumb]:border-orange-500 [&::-moz-range-thumb]:bg-viridian-500 [&::-webkit-slider-thumb]:pointer-events-auto [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:border-orange-500 [&::-webkit-slider-thumb]:bg-viridian-500",
        type: "range",
        min: _unref(LOCATION_AREA_MIN),
        max: _unref(LOCATION_AREA_MAX),
        step: _unref(LOCATION_AREA_STEP),
        value: localMax.value,
        "aria-label": "Maximum rentable surface",
        onInput: onMaxInput,
        onChange: commit
      }, null, 40, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[1] || (_cache[1] = _createElementVNode("label", {
        class: "sr-only",
        for: "location-area-min"
      }, "Minimum rentable surface (m²)", -1)),
      _createElementVNode("input", {
        id: "location-area-min",
        class: "w-full rounded-full border border-concrete-300 px-3 py-2 font-primary text-sm text-black focus:outline-none focus:ring-4 focus:ring-celestial-500",
        type: "number",
        min: _unref(LOCATION_AREA_MIN),
        max: _unref(LOCATION_AREA_MAX),
        step: _unref(LOCATION_AREA_STEP),
        value: localMin.value,
        onBlur: onMinNumberBlur
      }, null, 40, _hoisted_5),
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "shrink-0 font-primary text-sm text-concrete-700" }, "–", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("label", {
        class: "sr-only",
        for: "location-area-max"
      }, "Maximum rentable surface (m²)", -1)),
      _createElementVNode("input", {
        id: "location-area-max",
        class: "w-full rounded-full border border-concrete-300 px-3 py-2 font-primary text-sm text-black focus:outline-none focus:ring-4 focus:ring-celestial-500",
        type: "number",
        min: _unref(LOCATION_AREA_MIN),
        max: _unref(LOCATION_AREA_MAX),
        step: _unref(LOCATION_AREA_STEP),
        value: localMax.value,
        onBlur: onMaxNumberBlur
      }, null, 40, _hoisted_6),
      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "shrink-0 font-primary text-sm text-concrete-700" }, "m²", -1))
    ])
  ], 2))
}
}

})